var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "franquias" } },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.dashboard.manipulacoes_vue_html.franquias"
                        )
                      ) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("multiSelect-component", {
                attrs: {
                  id: "franquias",
                  name: "franquias",
                  options: _vm.franquiasOptions,
                  defaultValue: _vm.defaultFranquia,
                },
                model: {
                  value: _vm.franquiaIds,
                  callback: function ($$v) {
                    _vm.franquiaIds = $$v
                  },
                  expression: "franquiaIds",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c(
            "button",
            {
              staticClass: "ajuste-button-form",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.onSelecionarTodas()
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t(
                      "__.Components.parent.dashboard.evolucaoVendas_vue_html.todas"
                    )
                  ) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ajuste-button-form",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.onLimpar()
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.$t(
                      "__.Components.parent.dashboard.evolucaoVendas_vue_html.limpar"
                    )
                  ) +
                  "\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: { for: "grupoProdutoId" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.dashboard.produtosMaisVendidos_vue_html.grupoProduto"
                        )
                      ) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("combo-component", {
                attrs: {
                  id: "grupoProdutoId",
                  name: "grupoProdutoId",
                  data: _vm.grupoProdutoOptions,
                  searchable: true,
                },
                model: {
                  value: _vm.grupoProdutoId,
                  callback: function ($$v) {
                    _vm.grupoProdutoId = $$v
                  },
                  expression: "grupoProdutoId",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: { for: "tipoVenda", title: _vm.$t("__.obrigatorio") },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$t(
                          "__.Components.parent.venda.vendaForm_vue_html.tipoVenda"
                        )
                      ) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("combo-component", {
                attrs: {
                  id: "tipoVenda",
                  name: "tipoVenda",
                  data: _vm.tipoVendaOptions,
                  searchable: true,
                },
                model: {
                  value: _vm.tipoVenda,
                  callback: function ($$v) {
                    _vm.tipoVenda = $$v
                  },
                  expression: "tipoVenda",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("periodoFiltroComponent", { on: { onFilter: _vm.onUpdateDashboard } }),
      _vm._v(" "),
      _c("div", { staticClass: "row", staticStyle: { "margin-top": "20px" } }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c("div", { ref: "maisVendidosChart", style: _vm.graphStyle }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "grid-home" },
            [
              _c("grid-component", {
                attrs: {
                  data: _vm.maisVendidosData,
                  columns: _vm.gridColumns,
                  showSearchField: false,
                  showTools: false,
                  showAddNewButton: false,
                  showActionColumn: false,
                  showSortIcons: false,
                  showTableFoot: false,
                  pageSize: 10,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ver-mais-container" }, [
            _c(
              "button",
              {
                staticClass: "btn-ver-mais",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.onVerMais("mais")
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.dashboard.produtosMaisVendidos_vue_html.verMais"
                      )
                    ) +
                    "\n                    "
                ),
                _c("i", { staticClass: "fa fa-arrow-right" }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row", staticStyle: { "margin-top": "20px" } }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c("div", { ref: "menosVendidosChart", style: _vm.graphStyle }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c(
            "div",
            { staticClass: "grid-home" },
            [
              _c("grid-component", {
                attrs: {
                  data: _vm.menosVendidosData,
                  columns: _vm.gridColumns,
                  showSearchField: false,
                  showTools: false,
                  showAddNewButton: false,
                  showActionColumn: false,
                  showSortIcons: false,
                  showTableFoot: false,
                  pageSize: 10,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ver-mais-container" }, [
            _c(
              "button",
              {
                staticClass: "btn-ver-mais",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.onVerMais("menos")
                  },
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.dashboard.produtosMaisVendidos_vue_html.verMais"
                      )
                    ) +
                    "\n                    "
                ),
                _c("i", { staticClass: "fa fa-arrow-right" }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "modal-component",
        {
          ref: "modalVerMais",
          attrs: {
            title: _vm.verMaisTitulo,
            modalClass: "lm-modal",
            showBtnOk: false,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("grid-component", {
                attrs: {
                  data: _vm.verMaisData,
                  columns: _vm.gridColumnsVerMais,
                  tituloPagina: _vm.verMaisTitulo,
                  gridNameId: "verMais",
                  showSearchField: false,
                  showTools: true,
                  showAddNewButton: false,
                  showActionColumn: false,
                  showSortIcons: false,
                  pageSize: 9999,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }